import "autocompleter";

export default function () {
    (function ($) {
        $(function () {
            let cache = {};
            let container = document.createElement("div");
            let $container = $(container);
            let $loading = $('<svg class="autocomplete__loading" title="Načítání..." width="100" height="100"><use xlink:href="#search-loading" /></svg>');
            $(".navigation__search-input").each(function () {
                let input = this;
                let $input = $(this);

                function initAutocomplete() {
                    let $form = $input.closest('form');
                    let block_submit = false;
                    let last_ajax;
                    let $wrap = $input.closest('.navigation__search');
                    let isMobile = true;
                    let $desktop_search = $('.navigation__search--desktop');
                    if ($wrap.hasClass('navigation__search--desktop')) {
                        isMobile = false;
                        $wrap = $wrap.find('.navigation__search-form');
                    } else {
                        $input.on('blur', function (e) {
                            e.stopImmediatePropagation();
                        })
                    }
                    let $window = $(window);
                    $form.on('submit', function (e) {
                        if (block_submit) {
                            e.preventDefault();
                        }
                    })

                    function update_autocomplete() {
                        return autocomplete({
                            input: input,
                            minLength: 1,
                            disableAutoSelect: true,
                            container: container,
                            emptyMsg: "Žádné výsledky",
                            debounceWaitMs: 200,
                            showOnFocus: true,
                            customize: function (input, inputRect, container, maxHeight) {
                                if ($container.parent().get(0) !== $wrap.get(0)) {
                                    $wrap.append(container);
                                }
                            },
                            // preventSubmit: true,
                            onSelect: function (item, input) {
                                if (typeof item.name !== "undefined") {
                                    input.value = item.name;
                                }
                                if (typeof item.link !== "undefined") {
                                    block_submit = true;
                                    window.location.href = item.link;
                                } else {
                                    $(input).submit();
                                }
                            },
                            renderGroup: function (groupName, currentValue) {
                                let $group = $('<div class="autocomplete__group">' + groupName + '</div>');
                                return $group.get(0);
                            },
                            render: function (item, currentValue) {

                                return $(item.html).get(0);
                            },
                            fetch: function (text, update) {
                                if (!text) {
                                    update(null);
                                    return;
                                }
                                var term = text.toLowerCase();


                                if (term in cache) {
                                    update(cache[term]);
                                    return;
                                }
                                $wrap.append($container);
                                $container.html($loading);

                                let current_ajax = last_ajax = gp_ajax({
                                    url: $form.attr('action'),
                                    type: "get",
                                    dataType: 'json',
                                    data: {
                                        search: term,
                                        autocomplete: '1',
                                        'gp-ajax': 'autocomplete',
                                    }
                                }).done(function (response, textStatus, jqXHR) {
                                    cache[term] = response.data.search_result;
                                    if (last_ajax === current_ajax) {
                                        update(response.data.search_result);
                                    }
                                }).fail(function () {
                                    if (last_ajax === current_ajax) {
                                        update([]);
                                    }
                                });
                            }
                        })
                    }

                    let autocomplete_instance;

                    function update() {
                        if ($desktop_search.is(':visible')) {
                            if (isMobile) {
                                if (autocomplete_instance) {
                                    autocomplete_instance.destroy();
                                    autocomplete_instance = null;
                                }
                            } else {
                                if (!autocomplete_instance) {
                                    autocomplete_instance = update_autocomplete();
                                }
                            }
                        } else {
                            if (isMobile) {
                                if (!autocomplete_instance) {
                                    autocomplete_instance = update_autocomplete();
                                }
                            } else {
                                if (autocomplete_instance) {
                                    autocomplete_instance.destroy();
                                    autocomplete_instance = null;
                                }
                            }
                        }
                    }

                    update();
                    window.addEventListener('resize', update, {passive: true});
                }

                setTimeout(initAutocomplete);
            });


        });

        function highlightTextWithSearchedTerm(text, term) {
            const regex = new RegExp(term, "gi");
            text = text.trim();
            return text.replace(regex, "<strong>$&</strong>");
        }
    })(jQuery);
}